// extracted by mini-css-extract-plugin
export default {"group":"ConfigureAllowancesMultiselect_group__cqvpl","groupLabel":"ConfigureAllowancesMultiselect_groupLabel__Dy7cy"};